const cartDrawer = document.querySelector("c-drawer[data-component-id='cart-drawer']");
if (!cartDrawer) return;

// Guest membership toggle: flips the displayed prices instantly via
// #cart-form[data-wants-member] (CSS picks one of the two pre-rendered views), persists the
// choice, then dispatches the legacy event so handleMemberCart reconciles the drawer as before.

const STORAGE_KEY = 'wants_become_club_member';

function getForm() {
  return cartDrawer.querySelector('#cart-form');
}

function applyState(wantsMembership) {
  const form = getForm();
  if (form) {
    form.setAttribute('data-wants-member', wantsMembership ? 'true' : 'false');
    // marks a real user flip; the fade-in CSS only plays while this is present
    form.setAttribute('data-membership-flip', '');
    setTimeout(() => getForm()?.removeAttribute('data-membership-flip'), 400);
  }
  sessionStorage.setItem(STORAGE_KEY, wantsMembership ? 'true' : 'false');
}

function setSyncing(isSyncing) {
  const form = getForm();
  if (!form) return;
  if (isSyncing) form.setAttribute('data-membership-syncing', '');
  else form.removeAttribute('data-membership-syncing');
}

async function handleMembershipToggle(event) {
  const toggle = event.target.closest('#club-membership-toggle');
  if (!toggle) return;
  const wantsMembership = toggle.checked;

  applyState(wantsMembership);
  setSyncing(true);

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [STORAGE_KEY]: wantsMembership ? 'true' : 'false' } }),
    });
    if (!response.ok) throw new Error(`cart update failed: ${response.status}`);
    document.dispatchEvent(new CustomEvent('member-updated__from-toggle'));
  } catch (error) {
    console.error('Membership toggle failed to persist:', error);
    // revert the optimistic UI
    applyState(!wantsMembership);
    toggle.checked = !wantsMembership;
  } finally {
    setSyncing(false);
  }
}

cartDrawer.addEventListener('change', (event) => handleMembershipToggle(event));
